import styled from "styled-components";

import { CSSProperties, MouseEventHandler, ReactNode } from "react";
import { ChildrenType } from "../../types/common";

type TagSpanPropType = {
  children: ChildrenType;
  dark?: boolean;
  error?: boolean;
  primary?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const Wrapper = styled.section`
  width: 100%;
`;

const Header = styled.div`
  padding-bottom: 50px;
  @media (max-width: 960px) {
    width: 100%;
    text-align: center;
  }
`;

const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

const MapWrapper = styled.div`
  width: auto;
  height: 88%;
  border: 1px solid #d0d0d0;
  border-radius: 10px;
  overflow: hidden;
  @media (max-width: 960px) {
    height: 350px;
  }
`;

const RoundedContainer = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  border-radius: 30px;
`;

const Divider = styled.div`
  height: 1px;
  margin: 10px 0;
  background-color: #0000002a;
`;

export const LeftMenuButton = styled.button`
  padding: 10px 0 10px 15px;
  background: none;
  border: none;
`;

export const TagSpan = ({
  children,
  dark = false,
  error = false,
  primary = false,
  onClick,
}: TagSpanPropType) => {
  let color: string = "green";
  if (dark) color = "#fff";
  if (error) color = "#ff0000";
  if (primary) color = "green";

  const styles = {
    color: `${color}`,
    paddingTop: "2px",
    fontSize: "12px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    textAlign: "center",
    borderRadius: "15px",
    paddingInline: "15px",
    cursor: `${onClick && "pointer"}`,
  };
  return (
    <button onClick={onClick} style={styles as CSSProperties}>
      {children}
    </button>
  );
};

export const RowWrapper = styled.section`
  width: 100%;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

export { Wrapper, Header, BtnWrapper, MapWrapper, RoundedContainer, Divider };

export const ButtonWrapper = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        width: 200,
        padding: 12,
        paddingTop: 0,
        paddingBottom: 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
